import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  SellerBannerFetchApi,
  SellerDataFetchApi,
  SellerProductsFetchApi,
  SellerSpecialOfferFetchApi,
} from "../../ApiCalls/Seller";
import { SellerBrandFetchApi } from "../../ApiCalls/Brands";
import SearchInput from "../../components/Home/SearchInput/SearchInput";
import { GoHomeFill } from "react-icons/go";
import { BASE_URL } from "../../constant/api";
import OfferProductCard from "../../components/OfferProductCard/OfferProductCard";
import HomeCarousel from "../../components/Home/HomeCarousel/HomeCarousel";

const NearstSuppliers = () => {
  const { id } = useParams();
  const [sellerData, setSellerData] = useState({});
  const [brands, setBrands] = useState([]);
  const [banners, setBanners] = useState([]);
  const [products, setProducts] = useState([]);
  const [offerProducts, setOfferProducts] = useState([]);

  // Fetch seller details
  const fetchSellerData = async () => {
    try {
      const response = await SellerDataFetchApi(id);
      setSellerData(response.data);
      console.log(response);
    } catch (err) {
      console.error("Failed to load seller data:", err);
    }
  };

  // Fetch brands
  const fetchSellerBrands = async () => {
    try {
      const response = await SellerBrandFetchApi(id);
      setBrands(response?.Data || []);
    } catch (err) {
      console.error("Failed to load brands:", err);
    }
  };

  // Fetch banners
  const fetchSellerBanners = async () => {
    try {
      const response = await SellerBannerFetchApi(id);
      setBanners(response.Data || []);
    } catch (err) {
      console.error("Failed to load banners:", err);
    }
  };

  // Fetch special offers
  const fetchSpecialOffers = async () => {
    try {
      const response = await SellerSpecialOfferFetchApi(id);
      setOfferProducts(response || {});
    } catch (err) {
      console.error("Failed to load special offers:", err);
    }
  };

  // Fetch products
  const fetchSellerProducts = async () => {
    try {
      const response = await SellerProductsFetchApi(id);
      setProducts(response || []);
      // console.log(response.data);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
  };

  useEffect(() => {
    fetchSellerData();
    fetchSellerBrands();
    fetchSellerBanners();
    fetchSpecialOffers();
    fetchSellerProducts();
  }, [id]);

  return (
    <div className="w-full p-5">
      <h2 className="mb-4 text-3xl font-semibold">Nearest Suppliers</h2>

      {/* Seller Info */}
      <div className="mt-10 flex w-full flex-col justify-between md:flex-row">
        {sellerData && (
          <div className="flex gap-5">
            <img
              src={`${BASE_URL}${sellerData.logo}`}
              alt={sellerData.name}
              className="h-28 w-28 rounded-full object-contain"
            />
            <div className="flex flex-col justify-center">
              <h3 className="text-2xl font-semibold">{sellerData.name}</h3>
              <p className="text-sm">{sellerData.location}</p>
            </div>
          </div>
        )}
        <div className="mt-5 flex justify-center md:mt-0 md:flex-1 md:px-10">
          <SearchInput
            placeholder="Search product..."
            head=""
            icon={<GoHomeFill />}
          />
        </div>
      </div>

      {/* Banner Carousel */}

      {/* Brands */}
      <div className="mt-10">
        <h1 className="text-2xl font-medium">Brands</h1>
        <div className="flex w-full overflow-x-auto py-5">
          {brands.length > 0 ? (
            <ul className="flex gap-5">
              {brands?.map((brand) => (
                <Link
                  to={`/brands/${brand.id}`}
                  key={brand.id}
                  state={{ brand }}
                >
                  <li
                    className={`m-2 w-max cursor-pointer rounded-lg border p-2 shadow-md transition-all hover:shadow-2xl ${
                      id === String(brand.id)
                        ? "border-green-500"
                        : "border-gray-300"
                    }`}
                  >
                    <img
                      src={brand.image || "default-image-path.png"}
                      alt={brand.brandname || "Brand Image"}
                      style={{ width: "90px", height: "90px" }}
                      className="object-contain"
                    />
                  </li>
                </Link>
              ))}
            </ul>
          ) : (
            <p>Loading brands...</p>
          )}
        </div>
      </div>

      {/* Products */}
      <div className="mt-10 w-full">
        <h3 className="text-2xl font-semibold">Our Products</h3>
        <OfferProductCard products={products} />
      </div>
      <div className="mt-10">
        {banners.length > 0 ? (
          <HomeCarousel
            items={banners.map((banner) => ({
              id: banner.id,
              banner: banner.banner,
            }))}
          />
        ) : (
          <p></p>
        )}
      </div>

      {/* Special Offers */}
      <div className="mt-10 w-full">
        <h3 className="text-2xl font-semibold">Offer Products</h3>
        {offerProducts?.Data?.length > 0 ? (
          <OfferProductCard products={offerProducts.Data} />
        ) : (
          <p>No offer products available.</p>
        )}
      </div>
    </div>
  );
};

export default NearstSuppliers;
